import { connect } from 'react-redux';
import { TRIAL_PROJECT_LIMIT, TRIAL_SCHEDULE_LIMIT, TRIAL_ADDITIONAL_USER_LIMIT, TRIAL_DURATION_DAYS, ADDITIONAL_USER_DESCRIPTION, } from '../actions/types';

import Tooltip from './Tooltip';
import ChecklistIcon from '../icons/checklistIcon';

// Let a logged in user with no subscription of their own sign up for own
const TrialSubscriptionCard = ({ onClicked }) => {
  return (
    <div className='flex flex-col border w-full md:w-[350px] border-[#aaa] py-4 px-6 rounded-lg bg-[#00000066]'>
      <div className='text-[1.6em] font-bold'>Trial</div>
      <div className='h-[75px] text-base'>Great for getting started and running your first projects.</div>
      <div className='flex items-start h-[75px] mt-[10px]'>
        <div className='flex justify-center items-end'>
          <div className='text-[1.6em] leading-[1.2em] text-[#f9a928]'>FREE</div>
          <div className='opacity-80 ml-2'>for {TRIAL_DURATION_DAYS} days</div>
        </div>
      </div>
      <button 
        className='w-full font-bold p-[10px] border border-white hover:border-[#f9a928] hover:bg-[#f9a928] hover:text-black mr-2 rounded-lg'
        onClick={() => { 
          try {
            onClicked();
          } catch(error) {}
        }}
      >
        Start Trial Version
      </button>
      <div className='mt-[40px] mb-[20px] text-sm font-bold'>INCLUDES:</div>
      <div className='flex items-center gap-x-2'>
        <ChecklistIcon size='16' color='#55fa79' />
        <div>Up to {TRIAL_PROJECT_LIMIT} projects</div>
        {/*<div>Up to {TRIAL_ADDITIONAL_USER_LIMIT} Additional Users</div>*/}
      </div>
      <div className='flex items-center gap-x-2'>
        <ChecklistIcon size='16' color='#55fa79' />
        <div className='flex gap-2'>
          <div>Up to {TRIAL_ADDITIONAL_USER_LIMIT}</div>
          <Tooltip tooltipContent={ADDITIONAL_USER_DESCRIPTION}>
            <div className='underline decoration-dotted underline-offset-4 cursor-help'>additional users</div>
          </Tooltip>
        </div>
      </div>
      <div className='flex items-center gap-x-2'>
        <ChecklistIcon size='16' color='#55fa79' />
        <div>Email publishing</div>
        {/*<div>Up to {TRIAL_SCHEDULE_LIMIT} Schedules</div>*/}
      </div>
      <div className='flex items-center gap-x-2'>
        <ChecklistIcon size='16' color='#55fa79' />
        <div>Share schedule link</div>
        {/*<div>Up to {TRIAL_ADDITIONAL_USER_LIMIT} Additional Users</div>*/}
      </div>
      <div className='flex items-center gap-x-2'>
        <ChecklistIcon size='16' color='#55fa79' />
        <div>1-click PDF exports</div>
        {/*<div>Up to {TRIAL_PROJECT_LIMIT} Projects</div>*/}
      </div>
    </div>
  );
};

const mapStateToProps = state => { return {
}};
export default connect(mapStateToProps, { })(TrialSubscriptionCard);
